export const REPORT_FORM_DATA = 'REPORT_FORM_DATA';
export const REPORT_DIALOG_DATA = 'REPORT_DIALOG_DATA';
export const REPORT_LIST_DATA = 'REPORT_LIST_DATA';
export const BANK_ACCOUNTS_LIST = 'BANK_ACCOUNTS_LIST';
export const REPORT_DETAIL_DATA = 'REPORT_DETAIL_DATA';
export const ADMIN_SUPPORT_DATA = 'ADMIN_SUPPORT_DATA';
export const OBLIGATION_BY = 'OBLIGATION_BY';
export const SET_FILTERS_OPTIONS = 'SET_FILTERS_OPTIONS'
export const CLEAR_REPORT_FILTER = 'CLEAR_REPORT_FILTER'